module.exports = __webpack_public_path__ + "28b987dd1216c6f24b444614a6331c04.png";